<template>
  <div class="app" id="app"> 
      <!-- ASIDE CONTENT START (if user is logged)  --> 
      <navbar 
        v-if="logged && !login"  
      />
      <!-- ASIDE CONTENT END  -->
 
      <!-- MAIN CONTENT START  -->
      <main class="app-content">
        <transition name="fade" mode="out-in">
          <router-view/>
        </transition> 
      </main>
      <!-- MAIN CONTENT START  -->

      <preloader/>
  </div>  
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import login from '@/views/layout/index';
import navbar from '@/components/layout/TheNavbar';
import preloader from '@/components/layout/ThePreloader';
 
export default { 
  components: {
    login,
    navbar,
    preloader
  },
  computed: {
    ...mapGetters({
      logged: 'auth/logged'
    }), 
    login() { 
      return this.$route.meta.layout == 'public'
    }
  },  
  methods: {
    // ...mapMutations({
    //   loginUser: 'auth/loginUser'
    // }),
    checkAuth(v) {
      if(v != '/login' && this.logged == false) {
        this.$router.push({name: 'Login'}, () => { 
        });
      }
    }
  },
  watch: {
    $route(v) {
      this.checkAuth(v.path);
    }
  },
  created() { 
    this.checkAuth(this.$route.path);
  }
}
</script> 

<style lang="scss">
@import '@/assets/scss/main.scss';
@import '@/assets/scss/animation.scss';

#app {
  overflow: hidden;
} 

.app {
  width: 100%;
  display: flex;
  overflow: hidden;
  height: 100%;
 
  &-content {
    width: 100%; 
    height: 100vh;
    background-color: #f7fbfd;
    padding: 25px;
    // box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
  }  
} 

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
} 
</style>